import React, { useEffect } from 'react'
import { PageWrapper } from '../../Styles/style'
import Header from './Components/Header'
import S1_Token from './S1_Token'

import Aos from "aos";
import "aos/dist/aos.css";
import S2_Tokenomics from './S2_Tokenomics';
import S3_Faq from './S3_Faq';
const Token = () => {
    useEffect(() => {
        Aos.init({ duration: 2000 });
        window.addEventListener("load", function () {
          Aos.init();
        });
      }, []);
    return (
        <div>
            <PageWrapper>
                <S1_Token />
                <S2_Tokenomics />
                <S3_Faq />

            </PageWrapper>
        </div>
    )
}

export default Token